export function removeClass(items, css) {
    Array.prototype.forEach.call(items, (el) => {
        el.classList.remove(css)
    })
}

export function addClass(items, css) {
    Array.prototype.forEach.call(items, (el) => {
        el.classList.add(css)
    })
}

export function getParent(element, num) {
    var parent = element
    for (let i = 0; i < num; i++) {
        if (parent.parentNode) {
            parent = parent.parentNode
        }
    }
    return parent
}

export function triggerChange(element) {
    let changeEvent = new Event('change', {
        bubbles: true
    })
    element.dispatchEvent(changeEvent)
}

export function triggerClick(element) {
    let clickEvent = new Event('click')
    element.dispatchEvent(clickEvent)
}

export function formToJSON(elements) {
    return [].reduce.call(
        elements,
        (data, element) => {
            data[element.name] = element.value
            return data
        },
        {}
    )
}

export function getUrlString(data) {
    const urlParameters = Object.entries(data)
        .map(function (e) {
            return e.join('=')
        })
        .join('&')

    return urlParameters
}

export function getUrlParameter(sParam) {
    let sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=')

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1]
        }
    }
}

export function isNull(value) {
    return value === null
}

export function isUndefined(value) {
    return typeof value === 'undefined' || value === undefined
}

export function isEmpty(value) {
    if (value == null) {
        return true
    }

    if (typeof value === 'string') {
        return value.trim().length === 0
    }

    if (typeof value === 'object') {
        return Object.keys(value).length === 0
    }

    return false
}
